import { getAssetPath } from "@stencil/core";
import { logger } from "@axa-de/logger";
export const iconCache = new Map();
export const iconRequests = new Map();
export function fetchSvg(name) {
    // Assuming '[brand]-[type]-[name]'
    const parts = name.split('-');
    const brand = parts.length === 3 ? parts[0] : null;
    const type = parts.length === 3 ? parts[1] : parts[0];
    const fileName = parts.length === 3 ? parts[2] : parts[1];
    const url = brand !== null
        ? getIconSrc(`assets/icons/${brand}/${type}/${fileName}.svg`)
        : getIconSrc(`assets/icons/${type}/${fileName}.svg`);
    const req = fetch(url)
        .then(async (response) => {
        if (response.ok) {
            const content = await response.text();
            // Validate that the response is actually SVG content, not HTML
            if (content.trim().startsWith('<svg') && content.includes('</svg>')) {
                iconCache.set(name, content);
                return content;
            }
            else {
                throw new Error(`Response was not valid svg content`);
            }
        }
        else {
            throw new Error(`Invalid response from server - Status: ${response.status}`);
        }
    })
        .catch(error => {
        console.warn(`Icon '${name}' could not be loaded. (${error})`);
        throw error;
    })
        .finally(() => {
        iconRequests.delete(name);
    });
    iconRequests.set(name, req);
    return req;
}
/**
 * setAssetPath() is only included with the loader (dist/loader) which is not generated for dist-custom-elements.
 * dist-custom-elements does not dynamically fetch assets, so it must rely on correctly structured paths when importing.
 * Storybook serves the components differently, which can cause asset resolution issues.
 *
 * @param path
 * @private
 */
function getIconSrc(path) {
    // Get asset path, fallback to absolute path if getAssetPath() fails
    try {
        return getAssetPath(`${path}`);
    }
    catch (e) {
        logger.info('getAssetPath failed, using fallback path.');
        return `/${path}`;
    }
}
//# sourceMappingURL=utils.js.map
